<div class="container appointment-details-page">
  <div class="page-header">
    <div class="appointment-identity">
      <div class="appointment-heading">
        <div class="title-row">
          <h1 class="appointment-title">{{ appointment?.doctor?.name }}</h1>
          @if (appointment?.appointment?.status) {
            <span [class]="statusBadgeClass(appointment.appointment.status)">{{ appointment.appointment.status }}</span>
          }
          @if (appointment?.appointment?.payment_id) {
            <span class="status-badge status-paid">Paid</span>
          } @else {
            <span class="status-badge status-unpaid">Not paid</span>
          }
        </div>
        <div class="appointment-meta">
          <span class="meta-chip">{{ appointment?.appointment?.date | date:'dd MMM yyyy' }}</span>
          <span class="meta-chip">
            {{ appointment?.appointment?.date | date:'hh:mm a' }}
            –
            {{ appointment?.appointment?.end_date | date:'hh:mm a' }}
          </span>
          @if (appointment?.appointment?.period) {
            <span class="meta-chip">{{ appointment.appointment.period }} min</span>
          }
          @if (get_room(appointment?.appointment?.room)) {
            <span class="meta-chip">{{ get_room(appointment.appointment.room) }}</span>
          }
          @if (appointment?.appointment?.walkin) {
            <span class="meta-chip">Walk-in</span>
          }
          @if (appointment?.appointment?.overbooked) {
            <span class="meta-chip">Overbooked</span>
          }
        </div>
      </div>
    </div>
    <div class="header-actions">
      <button type="button" class="btn btn-brand"
        [hidden]="is_hidden_appointment(appointment.appointment)"
        [disabled]="allowed_to_close(appointment.appointment)"
        (click)="open_invocie_modal(invoice_content)">Invoice Payment</button>
      <a class="btn btn-outline-brand"
        (click)="print_invoice(appointment?.appointment.payment_id)"
        [hidden]="!is_hidden_appointment(appointment.appointment)">Print Invoice</a>
      <button type="button" class="btn btn-outline-brand"
        [hidden]="is_hidden(appointment.appointment)"
        (click)="open(service_content)">Add Service</button>
      <button type="button" class="btn btn-outline-brand"
        [hidden]="is_hidden(appointment.appointment)"
        (click)="open(items_content)">Buy an item</button>
      <button type="button" class="btn btn-outline-brand"
        [disabled]="!utility.isAllowed(['admin', 'accountant', 'doctor', 'staff'])"
        (click)="openEditAppointment(edit_appointment)">Edit</button>
      <button type="button" class="btn btn-outline-danger"
        [disabled]="!utility.isAllowed(['admin', 'accountant', 'doctor'])"
        (click)="onDeleteAppointment(appointment.appointment)">Delete</button>
    </div>
  </div>

  <div class="row g-3">
    <div class="col-lg-5 col-md-12">
      <div class="card details-card patient-card">
        <div class="patient-hero">
          <div class="patient-avatar" aria-hidden="true">{{ patientInitials }}</div>
          <div class="patient-heading">
            <h2 class="patient-name">
              @if (utility.isAllowed(['admin', 'accountant'])) {
                <a class="patient-name-link" [routerLink]="['/patient_details']"
                  [queryParams]="{ id: appointment?.appointment.patient_id }">
                  {{ appointment?.patient?.first_name }} {{ appointment?.patient?.last_name }}
                </a>
              } @else {
                {{ appointment?.patient?.first_name }} {{ appointment?.patient?.last_name }}
              }
            </h2>
            <div class="patient-id-row">
              @if (appointment?.patient?.patient_number) {
                <span class="patient-number">{{ appointment.patient.patient_number }}</span>
              }
              @if (appointment?.patient?.gender) {
                <span class="meta-chip">{{ appointment.patient.gender }}</span>
              }
              @if (appointment?.patient?.age) {
                <span class="meta-chip">{{ appointment.patient.age }} years</span>
              }
            </div>
          </div>
        </div>

        <div class="patient-facts">
          @if (utility.isAllowed(['admin', 'accountant']) && (appointment?.patient?.phone || appointment?.patient?.phone2)) {
            <div class="fact-row">
              <span class="fact-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58z"/>
                </svg>
              </span>
              <div class="fact-content">
                @if (appointment?.patient?.phone) {
                  <a class="phone-link" [href]="'tel:' + appointment.patient.phone">{{ appointment.patient.phone }}</a>
                }
                @if (appointment?.patient?.phone2) {
                  <a class="phone-link phone-link--alt" [href]="'tel:' + appointment.patient.phone2">{{ appointment.patient.phone2 }}</a>
                }
              </div>
            </div>
          }
          @if (appointment?.patient?.visiting_reason) {
            <div class="fact-row">
              <span class="fact-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5m1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0M1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5"/>
                </svg>
              </span>
              <div class="fact-content">
                <span class="fact-value">{{ appointment.patient.visiting_reason }}</span>
              </div>
            </div>
          }
          <div class="fact-grid">
            @if (utility.isAllowed(['admin', 'accountant']) && appointment?.patient?.birth_date) {
              <div class="fact-item">
                <span class="fact-label">Born</span>
                <span class="fact-value">{{ appointment.patient.birth_date | date:'dd MMM yyyy' }}</span>
              </div>
            }
            @if (appointment?.patient?.created_at) {
              <div class="fact-item">
                <span class="fact-label">Registered</span>
                <span class="fact-value">{{ appointment.patient.created_at | date:'dd MMM yyyy' }}</span>
              </div>
            }
          </div>
        </div>

        <div class="card-footer patient-footer">
          @if (utility.isAllowed(['admin', 'accountant'])) {
            <a [routerLink]="['/patient_details']" [queryParams]="{ id: appointment?.appointment.patient_id }"
              class="btn btn-sm btn-brand">Profile</a>
          }
          <a [routerLink]="['/invoices']" [queryParams]="{id: appointment?.appointment.patient_id}"
            class="btn btn-sm btn-outline-brand">Invoices</a>
          <a [routerLink]="['/appointments']" [queryParams]="{patient: appointment?.appointment.patient_id}"
            class="btn btn-sm btn-outline-brand">Appointments</a>
        </div>
      </div>

      @if (package) {
        <div class="card details-card mt-3">
          <div class="card-header d-flex justify-content-between align-items-center">
            <span>Patient Package</span>
            <span class="count-badge">{{ package.no_sessions_left }} left</span>
          </div>
          <div class="package-body">
            <div class="package-progress">
              <div class="package-progress-label">
                {{ package.no_sessions_took }} of {{ package.no_sessions }} sessions used
              </div>
              <div class="session-bar session-bar--lg" aria-hidden="true">
                <div class="session-bar-fill" [style.width.%]="sessionProgress(package)"></div>
              </div>
            </div>
            <div class="package-stats">
              <div class="package-stat">
                <span class="fact-label">Left</span>
                <span class="sessions-left" [class.sessions-left--empty]="package.no_sessions_left == 0">
                  {{ package.no_sessions_left }}
                </span>
              </div>
              <div class="package-stat">
                <span class="fact-label">Taken</span>
                <span class="package-stat-value">{{ package.no_sessions_took }}</span>
              </div>
              <div class="package-stat">
                <span class="fact-label">Total</span>
                <span class="package-stat-value">{{ package.no_sessions }}</span>
              </div>
            </div>
            <div class="package-pay">
              <span class="fact-label">Paid</span>
              <span class="package-pay-value">
                {{ package.paied_amount | number:'1.3-3' }}
                <span class="package-pay-total">/ {{ package.full_price | number:'1.3-3' }} OMR</span>
              </span>
            </div>
            <div class="package-pay">
              <span class="fact-label">Started</span>
              <span class="package-stat-value">{{ package.created_at | date: 'dd MMM yyyy' }}</span>
            </div>
          </div>
        </div>
      }

      <div class="card details-card mt-3">
        <div class="card-header d-flex justify-content-between align-items-center">
          <span>Services</span>
          <span class="count-badge">{{ 1 + sub_appointments.length }}</span>
        </div>
        <div class="card-body p-0">
          <div class="service-row">
            <div class="service-main">
              <span class="service-name">{{ appointment?.appointment?.service_name || '—' }}</span>
              @if (get_room_label(appointment?.appointment?.room) !== '—') {
                <span class="meta-chip">{{ get_room_label(appointment.appointment.room) }}</span>
              }
            </div>
            <div class="service-price">
              @if (!package) {
                {{ appointment?.appointment?.final_price | number:'1.3-3' }}
              } @else {
                {{ package.full_price | number:'1.3-3' }}
              }
              <small>OMR</small>
            </div>
          </div>
          @for (sub of sub_appointments; track sub) {
            <div class="service-row">
              <div class="service-main">
                <span class="service-name">{{ get_service_name(sub.service_id) || '—' }}</span>
                <span class="meta-chip">Extra</span>
              </div>
              <div class="service-price">
                {{ sub.amount_due | number:'1.3-3' }} <small>OMR</small>
              </div>
            </div>
          }
          @if (appointment?.appointment?.recommended_by) {
            <div class="service-footer">
              <span class="fact-label">Recommended by</span>
              <span class="fact-value">{{ get_doctor_name(appointment.appointment.recommended_by) }}</span>
            </div>
          }
        </div>
      </div>

      @if (history.length > 0) {
        <div class="card details-card mt-3">
          <div class="card-header d-flex justify-content-between align-items-center">
            <span>Past Sessions</span>
            <span class="count-badge">{{ history.length }}</span>
          </div>
          <div class="card-body p-0">
            <table class="table details-table history-table mb-0">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Clinician</th>
                  <th>Room</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody>
                @for (item of history; track item) {
                  <tr>
                    <td>
                      <span class="history-date">{{ item.date | date:'dd MMM yy' }}</span>
                      <span class="history-time">{{ item.date | date:'hh:mm a' }}</span>
                    </td>
                    <td>{{ get_doctor_name(item.doctor_id) || '—' }}</td>
                    <td>{{ get_room_label(item.room) }}</td>
                    <td>
                      @if (item.note_count) {
                        <span class="notes-count">{{ item.note_count }}</span>
                      } @else {
                        <span class="notes-count notes-count--empty">0</span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>

    <div class="col-lg-7 col-md-12">
      <div class="card details-card notes-card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <span>Clinician Notes</span>
          <span class="count-badge">{{ note.length }}</span>
        </div>
        <div class="card-body p-0">
          @if (note.length === 0) {
            <div class="empty-state">
              <p class="empty-title">No notes yet</p>
              <p class="empty-text">Add a clinician note for this appointment.</p>
              @if (api.canEnter(['doctor', 'admin'])) {
                <button type="button" class="btn btn-brand btn-sm" (click)="open(contentNoteNew)"
                  [disabled]="allowed_to_close(appointment.appointment)">Add New Note</button>
              }
            </div>
          } @else {
            @for (n of note; track n) {
              <article class="note-block">
                <div class="note-header">
                  <div>
                    <h3 class="note-title">{{ n?.title || 'Note' }}</h3>
                    <span class="note-date">{{ n?.open_date | date:'dd MMM yyyy' }}</span>
                  </div>
                  @if (api.canEnter(['doctor', 'admin'])) {
                    <div class="note-actions">
                      <button type="button" class="btn btn-sm btn-outline-secondary"
                        [disabled]="allowed_to_close(appointment.appointment)"
                        (click)="edit(contentNoteEdit, n)" aria-label="Edit note">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                          fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                          <path
                            d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                        </svg>
                      </button>
                      <button type="button" class="btn btn-sm btn-outline-danger"
                        [disabled]="!utility.isAdmin()" (click)="OnDelete(n.id)" aria-label="Delete note">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                          fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                          <path
                            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                          <path fill-rule="evenodd"
                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                        </svg>
                      </button>
                    </div>
                  }
                </div>
                <div class="note-body">{{ n?.description }}</div>
              </article>
            }
          }
        </div>
        @if (api.canEnter(['doctor', 'admin'])) {
          <div class="card-footer notes-footer">
            <button type="button" class="btn btn-brand" (click)="open(contentNoteNew)"
              [disabled]="allowed_to_close(appointment.appointment)">Add New Note</button>
            <a class="btn btn-outline-brand" (click)="print_note(note)">Print Notes</a>
            <a class="btn btn-outline-secondary" (click)="getHistoryNotes()">Notes History</a>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #edit_appointment let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Edit Appointment</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label" for="edit-clinician">Clinician</label>
        <select id="edit-clinician" class="form-select" [(ngModel)]="editAppointment.doctor_id">
          <option [ngValue]="null">-- SELECT --</option>
          @for (doctor of doctors; track doctor.id) {
            <option [ngValue]="doctor.id">{{ doctor.name }}</option>
          }
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label" for="edit-recommended">Recommended by</label>
        <select id="edit-recommended" class="form-select" [(ngModel)]="editAppointment.recommended_by">
          <option [ngValue]="null">-- SELECT --</option>
          @for (staff of staffs; track staff.id) {
            <option [ngValue]="staff.id">{{ staff.name }}</option>
          }
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label" for="edit-status">Status</label>
        <select id="edit-status" class="form-select" [(ngModel)]="editAppointment.status">
          @for (status of appointmentStatuses; track status) {
            <option [ngValue]="status">{{ status }}</option>
          }
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label" for="edit-date">Date &amp; Time</label>
        <input id="edit-date" type="datetime-local" class="form-control" [(ngModel)]="editAppointment.date">
      </div>
      <div class="col-md-8">
        <label class="form-label" for="edit-service">Type of Service</label>
        <select id="edit-service" class="form-select" [(ngModel)]="editAppointment.service_id"
          (change)="onEditServiceChange()" [disabled]="serviceLocked">
          <option [ngValue]="null">-- SELECT SERVICE --</option>
          @for (service of services; track service.id) {
            <option [ngValue]="service.id">{{ service.name }}</option>
          }
        </select>
        @if (serviceLocked) {
          <div class="form-text">Service stays as booked for paid visits and package sessions.</div>
        }
      </div>
      <div class="col-md-4">
        <label class="form-label" for="edit-price">Price</label>
        <input id="edit-price" type="number" class="form-control" [(ngModel)]="editAppointment.service_price" disabled>
      </div>
      <div class="col-md-6">
        <label class="form-label" for="edit-room">Room</label>
        <select id="edit-room" class="form-select" [(ngModel)]="editAppointment.room">
          <option [ngValue]="null">-- SELECT ROOM --</option>
          <option value="room_001">Tratment Room 1</option>
          <option value="room_002">Tratment Room 2</option>
          <option value="room_003">Tratment Room 3</option>
          <option value="room_004">Tratment Room 4</option>
          <option value="adult_gym">Adults Gym</option>
          <option value="swim_pool">Swimming Pool</option>
          <option value="paeds_gym">Paeds Gym</option>
          <option value="overbooked">Overbooked Room</option>
          <option value="home_visit">Home visiting</option>
          <option value="home_visit_ob">Home visiting (OB)</option>
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label" for="edit-period">Appointment Period</label>
        <div class="input-group">
          <input id="edit-period" type="number" class="form-control" min="1" step="1"
            [(ngModel)]="editAppointment.period" placeholder="e.g. 25">
          <span class="input-group-text">minutes</span>
        </div>
        @if (editPeriodRangeLabel) {
          <div class="form-text">{{ editPeriodRangeLabel }}</div>
        }
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.dismiss('Cross click')">Cancel</button>
    <button type="button" class="btn btn-success"
      [disabled]="savingAppointment || !editAppointment.doctor_id || !editAppointment.date || !editAppointment.service_id || !editAppointment.room || !editAppointment.period"
      (click)="updateAppointment()">
      {{ savingAppointment ? 'Saving...' : 'Update' }}
    </button>
  </div>
</ng-template>
<ng-template #invoice_content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Create Invoice</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <div class="row">
        <label class="form-label">Payment Details</label>
        <table class="table table-bordered">
          <thead>
            <tr style="background-color:aliceblue;">
              <th>Service</th>
              <th>Price</th>
              <th>Quantity</th>
              <th>Total</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (item of payment_services; track item) {
              <tr>
                <td>{{item.service_name}}</td>
                <td>{{item.service_price}}</td>
                <td>{{item.quantity}}</td>
                <td>{{item.final_price | number : '1.2-2'}}</td>
                <td>
                  <span class="text-danger" (click)="removeService(item)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3-fill" viewBox="0 0 16 16">
                      <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5"/>
                    </svg>
                  </span>
                </td>
              </tr>
            }
            <tr>
              <td colspan="3">
                Total to Pay
              </td>
              <td style="background-color:aliceblue;">
                {{(payment.final_price | number : '1.2-2')}}
              </td>
              <td></td>
            </tr>
            @if (package) {
              <tr>
                <td colspan="3">
                  Package Payment
                </td>
                <td style="background-color:aliceblue;">
                  <sup>{{package.paied_amount}}</sup>/<sub>{{package.full_price}}</sub>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="row mt-2">
        <div class="col">
          <label for="date" class="form-label">Payment Type</label>
          <select class="form-select" [(ngModel)]="payment.payment_type">
            <option [value]="'CASH'">CASH</option>
            <option [value]="'CARD'">CARD</option>
            <option [value]="'BANK'">BANK</option>
            <option [value]="'CHEQUE'">CHEQUE</option>
          </select>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <label for="price" class="form-label">Discounted Price <small>(finall price)</small></label>
          <input type="number" class="form-control" [(ngModel)]="payment.final_price_to_pay" id="price">
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="create()">Create Invoice</button>
  </div>
</ng-template>
<ng-template #contentNoteNew let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Add Note</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <div class="mb-3">
        <textarea class="form-control" id="notes" rows="10" cols="50"
        [(ngModel)]="notes.description"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="OnSumbit()">Submit Note</button>
  </div>
</ng-template>
<ng-template #contentNoteEdit let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Edit Note</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <div class="mb-3">
        <textarea class="form-control" id="notes" rows="10" cols="50"
        [(ngModel)]="edit_notes.description"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="OnUpdate(note_id)">Edit Note</button>
  </div>
</ng-template>
<ng-template #service_content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Add Extra Service</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="service" class="form-label">Type of Service</label>
          <select class="form-select" [(ngModel)]="service.id" (change)="getPrice()">
            <option [ngValue]="null">-- SELECT SERVICE --</option>
            @for (service of services; track service) {
              <option [ngValue]='service.id'>{{ service.name }}
              </option>
            }
          </select>
        </div>
        <div class="col">
          <label for="amount_due" class="form-label">Quantity</label>
          <input type="number" class="form-control" [(ngModel)]="service.quantity" id="amount_due"
            (change)="calculate_service()" (keyup)="calculate_service()" min="1">
        </div>
        <div class="col">
          <label for="price" class="form-label">Price</label>
          <input type="number" class="form-control" [(ngModel)]="service.final_price" id="price"
            disabled>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="price" class="form-label">Recommended by</label>
          <select class="form-select" [(ngModel)]="service.recommended_by">
            <option [ngValue]="null">-- SELECT --</option>
            @for (staff of staffs; track staff) {
              <option [ngValue]='staff.id'>{{ staff.name }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="add_service()">Add Service</button>
    <button type="button" class="btn btn-outline-dark"
    (click)="modal.dismiss('Cross click')">Cancel</button>
  </div>
</ng-template>
<ng-template #items_content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Buy extra Items</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="service" class="form-label">Select an Item</label>
          <select class="form-select" [(ngModel)]="item.id" (change)="getItemPrice()">
            <option [ngValue]="null">-- SELECT ITEM --</option>
            @for (item of items; track item) {
              <option [ngValue]='item.id'>{{ item.name }}
              </option>
            }
          </select>
        </div>
        <div class="col">
          <label for="amount_due" class="form-label">Quantity</label>
          <input type="number" class="form-control" [(ngModel)]="item.quantity" id="amount_due"
            (change)="calculate_item()" min="1">
        </div>
        <div class="col">
          <label for="price" class="form-label">Price</label>
          <input type="number" class="form-control" [(ngModel)]="item.final_price" id="price"
            disabled>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="price" class="form-label">Recommended by</label>
          <select class="form-select" [(ngModel)]="service.recommended_by">
            <option [ngValue]="null">-- SELECT --</option>
            @for (staff of staffs; track staff) {
              <option [ngValue]='staff.id'>{{ staff.name }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="add_item()">Add Item</button>
    <button type="button" class="btn btn-outline-dark"
    (click)="modal.dismiss('Cross click')">Cancel</button>
  </div>
</ng-template>
